export const coordenadores = [
    {
      nomeCurso: "Esg – Governança Ambiental, Social e Corporativa",
      nomeCoordenador: "Nivea Consuelo Carvalho dos Santos",
      linkLattes: "http://lattes.cnpq.br/seu-id-lattes"
    },
    {
      nomeCurso: "Gestão da Inovação com Ênfase em Pesquisa, Desenvolvimento e Inovação (Pd&I)",
      nomeCoordenador: "Coordenação",
      linkLattes: "http://lattes.cnpq.br/outro-id"
    },
    // Adicione mais cursos e coordenadores conforme necessário
  ];